import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { Observable } from 'rxjs/Observable';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthenticationInterceptorService implements HttpInterceptor {

  constructor(private appService: AppService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /*    if (this.appService.getAuthUser()) {
          req = req.clone({
            setHeaders: {
              organizationId: this.appService.getAuthUser().organizationId.toString()
            }
          });
        }*/
    if (
      req.url.includes(environment.apiUrl) ||
      req.url.includes(environment.parameterApiUrl) ||
      req.url.includes(environment.subscriptionApiUrl) ||
      req.url.includes(environment.btmApiUrl)
    ) {
      if (this.appService.getToken()) {

        req = req.clone({
          setHeaders: {
            Authorization: this.appService.getToken()
          }
        });
      }
    }

    return next.handle(req)
      .do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.appService.logoutUser();
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/services/authentication.service.ts